var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-payment-methods")))]),
      !_vm.loadingMandates
        ? _c(
            "w-card-content",
            { style: { padding: "0 0 0 0" } },
            [
              _c(
                "w-row",
                [
                  _vm.activeMandates.length == 0 && !_vm.showAddButton
                    ? _c("div", { style: { margin: "20px" } }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-sm-12" },
                            [
                              _c("w-info", {
                                attrs: {
                                  text: _vm.$ct("no-payment-methods-yet"),
                                  "ico-lib": "fas",
                                  ico: "info-circle",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.activeMandates, function (mandat) {
                    return _c(
                      "w-col",
                      {
                        key: mandat.id,
                        attrs: { sm: "12", md: _vm.limitMethods ? 6 : 4 },
                      },
                      [
                        _c("app-payment-method-item", {
                          attrs: { mandat: mandat },
                          on: {
                            refresh: function ($event) {
                              return _vm.getMandates()
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm.showAddButton
                    ? _c(
                        "w-col",
                        { attrs: { sm: "12", md: _vm.limitMethods ? 6 : 4 } },
                        [
                          _c("app-add-payment-method-button", {
                            attrs: { plan: _vm.plan },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _c("w-card-content", [_c("w-progress-circular")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }